import { FirebaseDocument } from "common/models/FirebaseDocument";
import {
  TFirestoreTimestamp,
  TQueryDocumentSnapshot,
} from "common/types/FirebaseTypes";
import { Bdi } from "./Bdi";

export class WBS {
  name: string;
  totalCost: number;
  childrenCount: number;
  development: string;
  decimalPlaces: number;
  roundingRule: "trunc" | "round";
  nameWbs: string;
  description: string;
  bdi: Bdi;
  totalSale: number;
  createdAt?: TFirestoreTimestamp;
  isSelected?: boolean;
  position?: any;
  updateCompositions?: any;

  hasCoefficient?: boolean;

  coefficient?: number;

  constructor(
    name: string,
    totalCost: number,
    childrenCount: number,
    development: string,
    decimalPlaces: number,
    roundingRule: "trunc" | "round",
    bdi: Bdi,
    totalSale: number,
    nameWbs?: string,
    description?: string,
    createdAt?: TFirestoreTimestamp,
    isSelected?: boolean,
    position?: any,
    updateCompositions?: any
  ) {
    this.name = name;
    this.totalCost = totalCost;
    this.childrenCount = childrenCount;
    this.development = development;
    this.decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;
    this.roundingRule = roundingRule !== undefined ? roundingRule : "trunc";
    this.bdi = bdi !== undefined ? bdi : { percentual: 0, show: false };
    this.totalSale = totalSale !== undefined ? totalSale : 0;
    this.nameWbs = nameWbs || name || "";
    this.description = description || "";
    this.createdAt = createdAt;
    this.isSelected = isSelected;
    this.position = position;
    this.updateCompositions = updateCompositions;
  }
}

export function fromFirestoreToWBS(
  doc: TQueryDocumentSnapshot
): FirebaseDocument<WBS> {
  const data = doc.data();
  return new FirebaseDocument<WBS>(
    doc.id,
    new WBS(
      data.name,
      data.totalCost,
      data.childrenCount,
      data.development,
      data.decimalPlaces,
      data.roundingRule,
      data.bdi,
      data.totalSale,
      data.nameWbs,
      data.description,
      data.createdAt,
      data.isSelected,
      data.position,
      data.updateCompositions
    )
  );
}



// WEBPACK FOOTER //
// ./src/modules/WBS/models/WBS.tsx